// always add active class to Simple Talk link in hub nav
const highlightHubNav = () => {
    const hubAnchor = document.querySelector('.nav-bar--dark a[href$="simple-talk/"]');
    if (hubAnchor) {
        hubAnchor.parentElement.classList.add('active');
    }
};


const init = () => {
    highlightHubNav();
};

export default {
    init
};